<template>
  <div>
    <el-alert title="Email Sent" type="primary" description="Forgotten password email successfully sent" show-icon></el-alert>
    <div class="form-action">
      <el-button type="text" @click="cancelLogIn">Back to login</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('auth', ['cancelLogIn']),
  }
}
</script>

<style lang="scss" scoped>
.form-action {
  margin-top: 30px;

  .el-button--text {
    margin-left: 0;
    color: #67C23A;
    padding-top: 6px;
    padding-bottom: 0;

    &:hover {
      font-weight: bold;
    }
  }
}
</style>
